import { render } from "./TeachingPlanGrid.vue?vue&type=template&id=319d0e0f&scoped=true&ts=true"
import script from "./TeachingPlanGrid.vue?vue&type=script&lang=ts"
export * from "./TeachingPlanGrid.vue?vue&type=script&lang=ts"

import "./TeachingPlanGrid.vue?vue&type=style&index=0&id=319d0e0f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-319d0e0f"]])

export default __exports__